import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

export default function IndexPage() {
	useEffect(() => {
		window.location.replace("https://broadsign.com");
	});

	return (
		<Layout>
			<SEO title="Redirecting to broadsign.com..." />
		</Layout>
	)
}